import type { ListBuilderList } from '../../../types';
import { createShopStandardColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Short Date list configuration
 * Items with expiring dates
 */
export const shopShortDateList: ListBuilderList = {
	id: 'shop_short_date',
	cacheTTL: 600000,
	name: 'Short Dated',
	type: 'default',
	active: true,
	sortOrder: 4,
	columns: createShopStandardColumns(),
	description: 'Items with expiring dates',
	defaultSortId: 'in_stock_first',
	requiredFields: SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'short_date',
					label: 'Short Dated',
				},
			],
		},
	},
};
